import React from 'react';

import Ads from '_components/Ads';

export default function ArticleAds() {
  return (
    <div className={`block mt-6 md:mt-0`}>
      <Ads
        desktop={{
          adsId: '/325540922/oneshift_web/desktop_article_detail_rect_atf_01',
          sizes: [[300, 250], 'fluid'],
        }}
        mobile={{
          adsId: '/325540922/oneshift_web/mobile_article_detail_rect_btf_01',
          sizes: [[300, 250], 'fluid'],
        }}
        divId="div-gpt-ad-article-detail-rect-01"
      />
      
      <div className="mt-8">
        <Ads
          desktop={{
            adsId: '/325540922/oneshift_web/desktop_article_detail_rect_atf_02',
            sizes: [[300, 250], 'fluid'],
          }}
          mobile={{
            adsId: '/325540922/oneshift_web/mobile_article_detail_rect_btf_02',
            sizes: [[300, 250], 'fluid'],
          }}
          divId="div-gpt-ad-article-detail-rect-02"
        />
      </div>
    </div>
  );
}
